import { useState, useEffect } from 'react';

/**
 * Subscribes to sync-status IPC events from the Electron main process.
 * Works only when running inside Electron — is a no-op in the web app.
 *
 * status shape: { status: 'idle' | 'pulling' | 'pushing' | 'pulled' | 'pushed' | 'error',
 *                 tournamentId, error? }
 */
export function useSyncStatus() {
  const [syncStatus, setSyncStatus] = useState({ status: 'idle' });

  useEffect(() => {
    if (!window.electronAPI) return;

    window.electronAPI.onSyncStatus((data) => {
      setSyncStatus(data);
      // Auto-reset to idle 4 s after success
      if (data.status === 'pulled' || data.status === 'pushed') {
        setTimeout(() => setSyncStatus({ status: 'idle' }), 4000);
      }
    });

    return () => window.electronAPI.removeSyncListeners();
  }, []);

  const isActive = syncStatus.status === 'pulling' || syncStatus.status === 'pushing';
  const isError  = syncStatus.status === 'error';
  const isDone   = syncStatus.status === 'pulled' || syncStatus.status === 'pushed';

  return { syncStatus, isActive, isError, isDone };
}
